import { createStore, combineReducers } from "redux"
import { AppState } from "./types"
import { devDocsReducer } from "./devdocs/reducers"

export const appReducer = combineReducers<AppState>({
  devDocs: devDocsReducer,
})

const store = createStore(appReducer)

export default store
